import { Navigate, Route, Routes } from 'react-router-dom'
import Home from './components/Home'
import LegalNotice from './components/LegalNotice'
import DiagnosticAmiante from './components/Diagnostic/DiagnosticAmiante'
import DiagnosticPlomb from './components/Diagnostic/DiagnosticPlomb'
import DiagnosticTermite from './components/Diagnostic/DiagnosticTermite'
import DiagnosticGaz from './components/Diagnostic/DiagnosticGaz'
import DiagnosticElectricity from './components/Diagnostic/DiagnosticElectricity'
import DiagnosticDPE from './components/Diagnostic/DiagnosticDPE'
import DiagnosticCarrez from './components/Diagnostic/DiagnosticCarrez'
import DiagnosticBoutin from './components/Diagnostic/DiagnosticBoutin'
import DiagnosticERP from './components/Diagnostic/DiagnosticERP'
import DiagnosticEnergy from './components/Diagnostic/DiagnosticEnergy'
import ExpertiseAmiante from './components/Expertise/ExpertiseAmiante'
import ExpertiseDPEMention from './components/Expertise/ExpertiseDPEMention'
import ExpertiseDPEConseil from './components/Expertise/ExpertiseDPEConseil'
import ExpertiseAccessibility from './components/Expertise/ExpertiseAccessibility'
import ExpertiseEnergy from './components/Expertise/ExpertiseEnergy'
import Expertise2D from './components/Expertise/Expertise2D'
import Expertise3D from './components/Expertise/Expertise3D'
import Contact from './components/Contact'
import Admin from './components/Admin/Admin'
import AdminSignIn from './components/Admin/AdminSignIn'
import Payment from './components/Payment/Payment'
import PaymentSuccess from './components/Payment/PaymentSuccess'
import PaymentError from './components/Payment/PaymentError'
import DiagnosticPDF from './components/Diagnostic/DiagnosticPDF'

export default function AppRoutes({ ip }) {



    return (

        <Routes>

            <Route path="/" element={<Home ip={ip} />} />
            <Route path="/diagnostic-amiante" element={<DiagnosticAmiante />} />
            <Route path="/diagnostic-plomb" element={<DiagnosticPlomb />} />
            <Route path="/diagnostic-termite" element={<DiagnosticTermite />} />
            <Route path="/diagnostic-gaz" element={<DiagnosticGaz />} />
            <Route path="/diagnostic-électricité" element={<DiagnosticElectricity />} />
            <Route path="/diagnostic-DPE" element={<DiagnosticDPE />} />
            <Route path="/loi-Carrez" element={<DiagnosticCarrez />} />
            <Route path="/loi-Boutin" element={<DiagnosticBoutin />} />
            <Route path="/diagnostic-ERP" element={<DiagnosticERP />} />
            <Route path="/audit-énergétique" element={<DiagnosticEnergy />} />
            <Route path="/diagnostic-amiante-avant-travaux" element={<ExpertiseAmiante />} />
            <Route path="/diagnostic-DPE-avec-mentions" element={<ExpertiseDPEMention />} />
            <Route path="/diagnostic-DPE-conseil" element={<ExpertiseDPEConseil />} />
            <Route path="/diagnostic-accessibilité-handicapé" element={<ExpertiseAccessibility />} />
            <Route path="/audit-énergétique-consultatif" element={<ExpertiseEnergy />} />
            <Route path="/plans-cotés-2D" element={<Expertise2D />} />
            <Route path="/plans-élévation-3D" element={<Expertise3D />} />
            <Route path="/contact" element={<Contact ip={ip} />} />
            <Route path="/mentions-légales" element={<LegalNotice />} />

            <Route path="/paiement/:paymentToken" element={<Payment />} />
            <Route path="/paiement/reussi/:paymentToken" element={<PaymentSuccess />} />
            <Route path="/paiement/refuse" element={<PaymentError />} />
            <Route path="/diagnostic/PDFVerification/:diagnosticToken" element={<DiagnosticPDF />} />

            <Route path="/administration" element={<Navigate to="/administration/diagnostic/0" />} />
            <Route path="/administration/:adminRouter/:id" element={<Admin ip={ip} />} />
            <Route path="/authentification" element={<AdminSignIn ip={ip} />} />

        </Routes>

    )


}
